import { InsurancePlan } from 'src/services/interfaces/insurance';

export const isActivePlan = (plan: InsurancePlan): boolean => !plan.archivedAt;

export const isActivePrice = (price: { archivedAt?: string | null }): boolean => !price.archivedAt;

export const withActivePricesOnly = (plan: InsurancePlan): InsurancePlan => ({
  ...plan,
  prices: plan.prices.filter(isActivePrice),
});
